import React from 'react';
import { Link } from 'react-router-dom';

const FinalCTASection = () => (
  <>
    {/* Green CTA Section */}
    <div className="py-16 bg-emerald-600 dark:bg-emerald-700">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-4xl font-bold text-white mb-6">Ready to Uncover Your Savings?</h2>
        <p className="text-lg text-emerald-100 dark:text-emerald-200 mb-8 leading-relaxed">
          Take the first step with our free, no-obligation assessment. Get your personalised
          savings roadmap
          <br />
          in just 15 minutes.
        </p>
        <Link
          to="/assessment/self-guided"
          className="bg-white dark:bg-gray-900 text-emerald-600 dark:text-emerald-400 px-8 py-4 rounded-lg font-semibold hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors inline-flex items-center gap-2"
        >
          Start Your Free Energy Savings Assessment
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </Link>
      </div>
    </div>

    {/* Dark Footer Section */}
    <footer className="bg-slate-900 dark:bg-black text-gray-300 dark:text-gray-400 py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <div className="flex items-center mb-6">
              <img
                src="https://customer-assets.emergentagent.com/job_iac-assessment/artifacts/2sjfdvkd_White%20logo%20-%20no%20background.png"
                alt="Rely Ability Energy Productivity"
                className="h-16 mr-4"
              />
            </div>
            <p className="text-gray-400 dark:text-gray-500 leading-relaxed">
              Helping industrial businesses identify and implement energy savings opportunities
              through comprehensive assessments and actionable recommendations.
            </p>
          </div>

          {/* Services Column */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-6">Services</h3>
            <ul className="space-y-4">
              <li>
                <a
                  href="#"
                  className="text-gray-400 dark:text-gray-500 hover:text-emerald-400 dark:hover:text-emerald-300 transition-colors"
                >
                  Energy Assessments
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-gray-400 dark:text-gray-500 hover:text-emerald-400 dark:hover:text-emerald-300 transition-colors"
                >
                  Savings Reports
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-gray-400 dark:text-gray-500 hover:text-emerald-400 dark:hover:text-emerald-300 transition-colors"
                >
                  Implementation Support
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-gray-400 dark:text-gray-500 hover:text-emerald-400 dark:hover:text-emerald-300 transition-colors"
                >
                  Vendor Marketplace
                </a>
              </li>
            </ul>
          </div>

          {/* Industries Column */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-6">Industries</h3>
            <ul className="space-y-4">
              <li>
                <a
                  href="#"
                  className="text-gray-400 dark:text-gray-500 hover:text-emerald-400 dark:hover:text-emerald-300 transition-colors"
                >
                  Food & Beverage Processing
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-gray-400 dark:text-gray-500 hover:text-emerald-400 dark:hover:text-emerald-300 transition-colors"
                >
                  Packaging Manufacturing
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-gray-400 dark:text-gray-500 hover:text-emerald-400 dark:hover:text-emerald-300 transition-colors"
                >
                  Metal Product Manufacturing
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-gray-400 dark:text-gray-500 hover:text-emerald-400 dark:hover:text-emerald-300 transition-colors"
                >
                  Chemicals & Pharmaceuticals
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-gray-400 dark:text-gray-500 hover:text-emerald-400 dark:hover:text-emerald-300 transition-colors"
                >
                  Mining & Primary Metals
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-gray-400 dark:text-gray-500 hover:text-emerald-400 dark:hover:text-emerald-300 transition-colors"
                >
                  Facilities Management
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-800 dark:border-gray-900 pt-8 mt-12 text-center">
          <p className="text-gray-500 dark:text-gray-600">© 2024 Rely Ability. All rights reserved.</p>
        </div>
      </div>
    </footer>
  </>
);

export default FinalCTASection;


